import React from "react";
import { Card, Form, Row, Col, Image } from "react-bootstrap";
import { useUploadFile } from "../../../../../../api/fileUpload/fileUpload.hooks";

const QuaidsQuoteSection = ({ data, onUpdate }) => {
  const { upload, isLoading: isUploading } = useUploadFile();

  const handleChange = (field, value) => {
    onUpdate({
      ...data,
      [field]: value
    });
  };

  const handleFileUpload = async (file) => {
    try {
      const res = await upload(file);
      if (res?.url) {
        handleChange('image', res.url);
      }
    } catch (err) {
      console.error("File upload failed:", err);
    }
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Quaid's Quote Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleChange('isVisible', e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Card.Body>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Quote</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={data.quote}
                  onChange={(e) => handleChange('quote', e.target.value)}
                  placeholder="Enter quote"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Author</Form.Label>
                <Form.Control
                  type="text"
                  value={data.author}
                  onChange={(e) => handleChange('author', e.target.value)}
                  placeholder="Enter author name"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Designation</Form.Label>
                <Form.Control
                  type="text"
                  value={data.designation}
                  onChange={(e) => handleChange('designation', e.target.value)}
                  placeholder="Enter designation"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Note</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={data.note}
                  onChange={(e) => handleChange('note', e.target.value)}
                  placeholder="Enter note"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Image</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    e.target.files?.[0] && handleFileUpload(e.target.files[0])
                  }
                />
                {isUploading && (
                  <div className="text-muted small mt-1">
                    Uploading...
                  </div>
                )}
                {data.image && (
                  <div className="mt-2">
                    <Image
                      src={data.image}
                      alt="Preview"
                      thumbnail
                      style={{ maxWidth: "200px" }}
                    />
                  </div>
                )}
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      )}
    </Card>
  );
};

export default QuaidsQuoteSection;
